import {
  TButtonTranslations,
} from './npm-controller-menu.ts';

const buttonTranslations: TButtonTranslations = {
  LOAD_JOB: {
    label: 'Charge laden',
    confirmMessage: '',
    confirmHeader: '',
    confirmLabel: '',
  },
  START_JOB: {
    label: 'Charge starten',
    confirmMessage: 'Der Auftrag startet sofort.',
    confirmHeader: '{recipeCode} auf {assetDisplayName} starten?',
    confirmLabel: '{recipeCode} starten',
  },
  ABORT_JOB: {
    label: 'Charge abbrechen',
    confirmMessage: 'Der laufende Auftrag stoppt sofort.',
    confirmHeader: 'Auftrag {jobNo} ({recipeCode}) auf {assetDisplayName} abbrechen?',
    confirmLabel: '{jobNo} abbrechen',
  },
  RESUME_JOB: {
    label: 'Charge fortführen',
    confirmMessage: 'Der Auftrag wird dort fortgesetzt, wo er angehalten wurde.',
    confirmHeader: '{recipeCode} auf {assetDisplayName} fortführen?',
    confirmLabel: '{recipeCode} fortführen',
  },
};

export default {
  button: buttonTranslations,
};
